// Replay a click-triggered keyframe from the start on every press: drop the run
// class, force a reflow so the browser registers the removal, then re-add — so the
// full motion plays on each click regardless of how fast the presses repeat.
// Used by the wages cards (rpay-pop). The Daily desk buttons dropped their pulse
// when their writes became optimistic — see 05-today.css.
export function replayAnim(el: HTMLElement): void {
  el.classList.remove('anim-run');
  void el.offsetWidth;
  el.classList.add('anim-run');
}
